import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export interface SiteRouterInput {
  serial_number: string;
  mac_address: string;
  in_use: boolean;
  /** 설치 위치·특이사항 등 자유 메모 */
  note: string;
}
export interface SiteRouter extends SiteRouterInput {
  id: number;
  site_project_id: number;
}
const path = (site: number) => `/v0.1/site-management/projects/${site}/routers`;

export class SiteRouterService {
  static async list(site: number): Promise<SiteRouter[]> {
    return unwrapList(
      await apiClient.get<ApiListResponse<SiteRouter>>(path(site)),
      '라우터 목록 조회 실패',
    );
  }
  static async save(site: number, input: SiteRouterInput, id?: number): Promise<SiteRouter> {
    const response = id
      ? await apiClient.put<ApiItemResponse<SiteRouter>>(`${path(site)}/${id}`, input)
      : await apiClient.post<ApiItemResponse<SiteRouter>>(path(site), input);
    return unwrapItem(response, '라우터 저장 실패');
  }
  /** 현장에서 해지해 회사 보관(미사용)으로 옮긴다. */
  static async release(site: number, id: number): Promise<void> {
    ensureOk(await apiClient.post<ApiOkResponse>(`${path(site)}/${id}/release`), '라우터 해지 실패');
  }
  static async delete(site: number, id: number): Promise<void> {
    ensureOk(await apiClient.delete<ApiOkResponse>(`${path(site)}/${id}`), '라우터 삭제 실패');
  }
}
